export {
  default as halfCourt,
  ReactComponent as HalfCourt,
} from '@assets/icons/half-court.svg'
